import { useState, useEffect } from "react";
import { TagsInput } from "react-tag-input-component";
import axios from "axios";
import config from "../../config/config";

const CustomField = ({ cardData, handleChange }) => {
    const token = localStorage.getItem("Token");
    const [type, setType] = useState([]);
    const [location, setLocations] = useState([]);
    const [loading, setLoading] = useState(false);
    const [inputVisible, setInputVisible] = useState(false);
    const [selectedItems, setSelectedItems] = useState([]);
    const [selectedLocationItems, setSelectedLocationItems] = useState([]);
    const [selectedDropdownIndex, setSelectedDropdownIndex] = useState([]);// dropdowns index
    const [selectedDropdownIndexFlag, setSelectedDropdownIndexFlag] = useState([]); // dropdowns index flags
    const [selectedCheckedIndex, setSelectedCheckedIndex] = useState([]); // checkbox index
    const [selectedCheckedIndexFlag, setSelectedCheckedIndexFlag] = useState([]); // checkbox index flags

    const [check, setCheck] = useState([]); // for loactions checkbox

    const handleCheck = (index, evnt) => {
        if (check[index] === undefined) {
            check[index] = [];
        }
        const updatedList = check[index]; // [...check];

      
        if (evnt.target.checked) {
            updatedList.push(evnt.target.value);
        } else {
            updatedList.splice(check.indexOf(evnt.target.value), 1);
        }

        //object for sent values for handlechnage
        let event = {
            target: {
                name: 'Locations',
                value: updatedList.toString()
            }
        }
        check[index] = updatedList;

        handleChange(index, event)
    };

    // Return classes based on whether item is checked  
    var isCheck = (item) => check.includes(item.Id) ? "checked-item" : "not-checked-item";

    useEffect(() => {

        //fordropdown values
        axios.get(`${config.suppliersBaseUrl}/suppliers/selectalltype`, {
            headers: {
                "Content-Type": "application/json;charset=UTF-8",
                Authorization: token,
            },
        })
            .then((res) => {
                setLoading(false);
                setType(res.data.ResponseData);
            })
            .catch((err) => {
               
                setLoading(false);
            });

        // for loactions checkbox
        axios.get(`${config.priceRulesBaseUrl}/pricerules/locationdropdown`, {
            headers: {
                "Content-Type": "application/json;charset=UTF-8",
                Authorization: token,
            },
        })
            .then((res) => {
                setLoading(false);
                setLocations(res.data.ResponseData);
            })
            .catch((err) => {
              
                setLoading(false);
            });

    }, []);

    return cardData?.map((data, index) => {
        const { Id, Name, TypeId, Optionvalue, ShowOnReceipt, HideFieldLabel, Required, Locations } = data;

        // split data of Optionvalues
        const splitValue = Optionvalue?.split(',');
        if (splitValue !== undefined) {
            if (splitValue[0] != '' && splitValue[0] != null && splitValue[0] != undefined) {
                selectedItems[index] = splitValue;
            }
        }

        // split data of locations
        const splitLocationValue = Locations?.split(',');
        if (splitLocationValue !== undefined) {
            if (splitLocationValue[0] != '' && splitLocationValue[0] != null && splitLocationValue[0] != undefined) {
                selectedLocationItems[index] = splitLocationValue;
            }
        }

        const handleItemChange = (evnt) => {
            selectedItems[index] = evnt;
            handleChange(index, selectedItems[index]);
        }

        // handle for Dropdown 
        const handleDropdown = (index, evnt) => {
            if (evnt.target.value === "2") {
                setSelectedDropdownIndex([...selectedDropdownIndex, index]);
                setSelectedDropdownIndexFlag([...selectedDropdownIndexFlag, true]);
                setInputVisible(true);
            } else {
                const selectedDropdownValueIndex = selectedDropdownIndex.indexOf(index);
                if (selectedDropdownValueIndex > -1) {
                    setSelectedDropdownIndex(selectedDropdownIndex.filter(i => i !== index));
                    setSelectedDropdownIndexFlag(selectedDropdownIndexFlag.filter((_, i) => i !== selectedDropdownValueIndex));
                }
                setInputVisible(true);
            }
        };

        // handel of Required field checkbox
        const handleChangeRequiredChatBox = (index, evnt) => {
            if (evnt.target.checked) {
                setSelectedCheckedIndex([...selectedCheckedIndex, index]);
                setSelectedCheckedIndexFlag([...selectedCheckedIndexFlag, true]);
                setInputVisible(true);
            } else {
                const selectedCheckedValueIndex = selectedCheckedIndex.indexOf(index);
                if (selectedCheckedValueIndex > -1) {
                    setSelectedCheckedIndex(selectedCheckedIndex.filter(i => i !== index));
                    setSelectedCheckedIndexFlag(selectedCheckedIndexFlag.filter((_, i) => i !== selectedCheckedValueIndex));
                }
                setInputVisible(true);
            }
        };


        return (
            <div className="card mb-2" key={index}>
                <div className="card-header">
                    <h5 className="card-title">Custom Field {index + 1}</h5>
                </div>
                <div className="card-body">
                    <div className="row">

                        <input type='hidden' name="Id" value={Id} />

                        {/* Name */}
                        <div className="col-sm-12">
                            <div className="form-group row">
                                <label className="col-form-label col-md-2">
                                    Name <span className="text-danger">*</span>
                                </label>
                                <div className="col-md-10">
                                    <input type='text' className="form-control"
                                        name="Name"
                                        value={Name}
                                        onChange={(evnt) => (handleChange(index, evnt))}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* type */}
                        <div className="col-sm-12">
                            <div className="form-group row">
                                <label className="col-form-label col-md-2">Type</label>
                                <div className="col-md-10">
                                    <select
                                        name="TypeId"
                                        className="form-control custom_field_type"
                                        value={TypeId}
                                        onChange={(evnt) => {
                                            (handleDropdown(index, evnt));
                                            (handleChange(index, evnt));
                                        }}>
                                        {type.map((option) => (
                                            <option value={option.Id}>{option.Name}
                                            </option>
                                        ))}
                                    </select>
                                    <div key={index} className={`${(selectedDropdownIndexFlag.length > 0 && selectedDropdownIndex.includes(index) && selectedDropdownIndexFlag[selectedDropdownIndex.indexOf(index)] === true) || (TypeId == 2) ? '' : 'd-none'}`}>
                                        <TagsInput
                                            value={splitValue}
                                            placeHolder="Enter Options..."
                                            onChange={handleItemChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Show receipt */}
                        <div className="col-sm-12">
                            <div className="form-group row">
                                <label className="col-form-label col-md-2">
                                    Show On Receipt:
                                </label>
                                <div className="col-sm-9 col-md-9 pt-2 col-lg-10">
                                    <input
                                        className="form-check-input"
                                        style={{ width: "1.25em", height: "1.25em" }}
                                        type="checkbox"
                                        checked={ShowOnReceipt == 1 ? true : false}
                                        name="ShowOnReceipt"
                                        onChange={(evnt) =>
                                            (handleChange(index, evnt))
                                        }
                                    />
                                </div>
                            </div>
                        </div>

                        {/* hide field*/}
                        <div className="col-sm-12">
                            <div className="form-group row">
                                <label className="col-form-label col-md-2">
                                    Hide Field Label:
                                </label>
                                <div className="col-sm-9 col-md-9 pt-2 col-lg-10">
                                    <input
                                        className="form-check-input"
                                        style={{ width: "1.25em", height: "1.25em" }}
                                        type="checkbox"
                                        checked={HideFieldLabel == 1 ? true : false}
                                        name="HideFieldLabel"
                                        onChange={(evnt) =>
                                            (handleChange(index, evnt))
                                        }
                                    />
                                </div>
                            </div>
                        </div>

                        {/* required */}
                        <div className="col-sm-12">
                            <div className="form-group row">
                                <label className="col-form-label col-md-2">Required</label>
                                <div className="col-sm-9 col-md-9 pt-2 col-lg-10">
                                    <input
                                        className="form-check-input"
                                        style={{ width: "1.25em", height: "1.25em" }}
                                        type="checkbox"
                                        name="Required"
                                        checked={Required == 1 ? true : false}
                                        onChange={(evnt) => {
                                            (handleChangeRequiredChatBox(index, evnt));
                                            (handleChange(index, evnt))
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className={`col-sm-12 ${(selectedCheckedIndexFlag.length > 0 && selectedCheckedIndex.includes(index) && selectedCheckedIndexFlag[selectedCheckedIndex.indexOf(index)] === true) || (Required == 1) ? '' : 'd-none'}`}>
                            <div className="row">
                                <label className="col-form-label col-md-2">Locations:</label>
                                <div className="col-sm-9 col-md-3 mr-2 pt-2 col-lg-10">
                                    <div className="form-check mb-1">
                                        {location.map((item) => {
                                           
                                            return (<div key={item.Id}>
                                                <input
                                                    className="form-check-input me-3"
                                                    style={{ width: "1.25em", height: "1.25em" }}
                                                    name="Locations"
                                                    type="checkbox"
                                                    defaultChecked={splitLocationValue.indexOf(item.Id.toString()) > -1 ? true : false}
                                                    onChange={(evnt) => {
                                                        (handleCheck(index, evnt))
                                                    }}
                                                    value={item.Id} />
                                                <label className={isCheck(item.Id)}>{item.Name}</label>
                                            </div>
                                            )
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        )
    })
}

export default CustomField;
